import { api } from '@/lib/api'
import { API_PATHS } from '@/constants/api-paths'
import type { ApiResponse } from '@/types'

export interface PayTypeChoice {
  value: string
  label: string
}

type PayTypeChoicesPayload = {
  choices?: PayTypeChoice[]
}

const unwrapChoices = (payload: unknown): PayTypeChoice[] => {
  if (Array.isArray(payload)) {
    return payload
  }

  if (typeof payload === 'object' && payload !== null) {
    if ('data' in payload) {
      const nested = (payload as ApiResponse<PayTypeChoicesPayload>).data
      if (Array.isArray(nested)) {
        return nested
      }
      return nested?.choices ?? []
    }

    if ('choices' in payload) {
      return (payload as PayTypeChoicesPayload).choices ?? []
    }
  }

  return []
}

export const payTypesApi = {
  getChoices: async (): Promise<PayTypeChoice[]> => {
    const { data } = await api.get<ApiResponse<PayTypeChoicesPayload> | PayTypeChoicesPayload>(
      API_PATHS.payTypes.list,
    )
    return unwrapChoices(data)
  },
}
